import { render, staticRenderFns } from "./matcher-form.vue?vue&type=template&id=54c69dd3&"
import script from "./matcher-form.vue?vue&type=script&lang=js&"
export * from "./matcher-form.vue?vue&type=script&lang=js&"
import style0 from "./matcher-form.vue?vue&type=style&index=0&id=54c69dd3&prod&media=screen&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports